import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";
import { debug } from "util";

@Injectable()
export class InProductsService {
  constructor(private auth: AuthenticationService, private http: Http) { }

  //--------------Product-----------------//
  GetProductSearch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductSearch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getProductByBarcode(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductDetailsByBarcode",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getUnitByBarcode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_UnitByBarcode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getproducts(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Product",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ProductByBarcode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductByBarcode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_AtributesByBarcode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_AtributesByBarcode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSup(FilterBarcode: any) {
    return this.http.post(this.auth.baseUrl + "/services/api/v1/Get_ProductByBarcode", FilterBarcode,
      this.auth.getHeader()).map((res: Response) => res.json());

  }
  getproductById(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductById",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getItemId() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_ItemId",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GenBarcode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_GenBarcode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetDeptByCode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DepartmentsByCode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveProduct(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_Product",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UpdateProduct(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Product",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  checkBarcodeDuplicate(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/BarcodeDuplicate",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSellingPriceLevelByComapny(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetSellingPriceLevelByComapny",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_AllSellingPriceLevels(FilterBarcode: any) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Get_AllSellingPriceLevels",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  ImportitemsfromExcel(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Itemsfromexcel",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetItem_for_DeleteItem(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetItem_for_DeleteItem",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_Item(Barcode: string) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Delete_Item?Barcode=" + Barcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_ImportSingleProduct(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ImportSingleProduct",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_SellingPriceByCustomer(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SellingPriceByCustomer",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_Importpromotionitemsfromexcel(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Importpromotionitemsfromexcel",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_BarcodeOtherDetails(Filter: any){
    return this.http
    .post(
      this.auth.baseUrl + "/services/api/v1/Get_BarcodeOtherDetails",
      Filter,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
  }

  Get_SellingPriceListByBarcode(Filter: any){
    return this.http
    .post(
      this.auth.baseUrl + "/services/api/v1/Get_SellingPriceListByBarcode",
      Filter,
      this.auth.getHeader()
    )
    .map(res => {
      return res.json();
    });
  }
  //--------------Product-----------------//
  //--------------Department--------------//
  getDepartment(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Department",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetDepartmentByunderId(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetDepartmentByunderId",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  PromisGetDepartmentByunderId(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetDepartmentByunderId",
        FilterBarcode,
        this.auth.getHeader()
      ).toPromise();
  }
  getDepartmentAndCategory(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DepartmentAndCategory",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCategory(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Category",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSubcategory(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SubCategory",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCategoryByDept(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CategoryByDept",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSubCategoryBycat(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SubCategoryByCatId",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCategoryBySubcat(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CatBySubcat",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getdeptBycat(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeptByCat",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getDeptById(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeptById",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getDeptByCode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeptByCode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getParentGroup(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl +
          "/services/api/v1/Get_ProductGroup?ItemType=" +
          Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  saveDepartmentMaster(Data: any) {
    if (Data.id != 0) {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_Dept",
          Data,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Dept",
          Data,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getNewCode(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_NewCode",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  deleteDepartment(Id) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/v1/Delete_Dept?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSalesHistory(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/SalesHistory",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getTransactionHistory(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/TransactionsHistory",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Department--------------//
  //---------------Barcode Print----------//

  barcodePrintField(body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/BarcodePrintField",
        body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveasFile(body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Sent_Print",
        body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Translate(body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "services/api/v1/Translate?text=", body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Barcode Print----------//
  //----------------Currency------------//
  Save_CurrencyMaster(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_CurrencyMaster",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_CurrencyMaster(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_CurrencyMaster",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CurrencyMasterById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CurrencyMasterById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CurrencyMasterList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CurrencyMasterList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_CurrencyMaster(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_CurrencyMaster",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //----------------Currency------------//
  //----------------Item Master Tool------------//
  Swap_Barcode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Swap_Barcode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Merge_Barcode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Merge_Barcode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_AlternativeItemByMasterId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_AlternativeItemByMasterId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ImageOnFetchOne(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ImageOnFetchOne",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ImagesOnFetchImages(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ImagesOnFetchImages",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ImageAsBase64(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ImageAsBase64",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ImageOnFetchForPromotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ImageOnFetchForPromotion",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ItemImageByBarcode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ItemImageByBarcode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_ImageFromPromotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_ImageFromPromotion",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_SingleImageFromPromotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_SingleImageFromPromotion",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //----------------Item Master Too;------------//
  //--------------sellingPrice------------------//
  Get_SellingPriceDetailsForEdit(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SellingPriceDetailsForEdit",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SellingPriceFromProduct(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SellingPriceFromProduct",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SellingPriceByBarcode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SellingPriceByBarcode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Selling Price---------------//
  //---------------Stock----------------------//
  Get_LocationStockListByBarcode(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_LocationStockListByBarcode",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---------------Stock----------------------//
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-products.service.ts